export default __webpack_public_path__ + "static/media/ninjaprinthouse-logo_white.45d3ba93.png";